module.exports = __webpack_public_path__ + "static/media/download.40696f8c.svg";